import React from "react"

import UIHeader from "@ecom/ui/components/HeaderNew"
import Button from "@material-ui/core/Button"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import { AppLink } from "@ecom/ui/components/AppLink"
import * as styles from "./header.module.scss"
import scrollToPersonalForm from "../../../helpers/scrollToPersonalForm"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"
import { SovcomLogo } from "../Logos"

export type HeaderProps = {
  buttonText?: string
}

const classes = {
  container: styles.container,
}

export const Header = ({ buttonText = "Оформить" }: HeaderProps) => {
  const isTablet = useMediaQuery("(min-width:599px)")

  const onLogoClick = () => {
    DLClickEventExtended({ name: "Логотип", eventAction: "Клик на логотип", placement: "header" })
  }

  const LogoWithLink = () => (
    <AppLink
      href="https://scb.ru/"
      target="_blank"
      rel="noreferrer"
      onClick={onLogoClick}
      className={styles.logo}
    >
      <SovcomLogo />
    </AppLink>
  )

  const rightSection = (
    <Button onClick={scrollToPersonalForm} classes={{ root: styles.btn }}>
      {buttonText}
    </Button>
  )

  return (
    <UIHeader sticky={isTablet} left={<LogoWithLink />} right={rightSection} classes={classes} />
  )
}
